import React from 'react';
import { motion } from 'framer-motion';

const TestimonialFeature = () => {
  return (
    <section className="py-16 px-4 bg-[#F8FAFC]">
      <div className="max-w-3xl mx-auto">
        <motion.div 
          className="bg-white rounded-2xl p-8 md:p-12 shadow-sm"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex flex-col md:flex-row items-start gap-8 mb-12">
            <motion.img
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              src="/faisal-profile.jpg"
              alt="Faisal"
              className="w-48 object-cover"
            />
            <div>
              <motion.h3 
                className="text-4xl font-bold text-gray-900 mb-4"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                A Career in Cloud Can Completely Change Your Life – It Changed Mine.
              </motion.h3>
              <motion.p 
                className="text-xl text-gray-600"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                From IT Support to Cloud & DevOps Engineer
              </motion.p>
            </div>
          </div>

          <motion.div 
            className="space-y-4 text-gray-700"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            <p>
              After graduating from university in 2014, I landed my first IT job nine months later as an IT Support Engineer. I stayed with the same company for five years, working my way up to Systems Administrator.
            </p>
            
            <p>
              In 2017, I wrote my first PowerShell script to automate user account creation in Active Directory and that's when I discovered my passion for automation.
            </p>

            <p>
              From that moment on, I became obsessed with streamlining processes and eliminating repetitive tasks, which eventually led me into DevOps and Cloud Engineering.
            </p>

            <p>
              When I first heard of DevOps, I had zero experience. I didn't know anything about Azure, Infrastructure as Code, CI/CD, or cloud security, I was just figuring things out as I went.
            </p>

            <p>
              But I put in the work, learning, experimenting, and earning certifications. Over time, I built the skills that not only accelerated my career but also significantly increased my earning potential.
            </p>

            <div className="bg-[#F8FAFC] rounded-xl p-6 mt-6">
              <p className="font-semibold mb-4">Fast forward to today:</p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-[#0EA5E9] mr-3">✅</span>
                  <span>I've worked with top companies as an Azure Cloud & DevOps Engineer, earning a 6 figure salary, while working fully remote.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#0EA5E9] mr-3">✅</span>
                  <span>I hold multiple Azure, Kubernetes, and cloud certifications.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#0EA5E9] mr-3">✅</span>
                  <span>I've helped countless IT professionals transition into cloud engineering roles.</span>
                </li>
              </ul>
            </div>

            <p className="mt-6 font-medium">
              Now, I want to help you do the same.
            </p>

            <p>
              That's why I created the Cloud Acceleration Program (CAP), a step-by-step training programme designed to take you from zero cloud experience to confidently deploying cloud infrastructure like a pro.
            </p>

            <p>
              Whether you're an IT professional looking to transition into cloud or a complete beginner, CAP will provide you with the skills, hands-on experience, and expert guidance to land a high-paying cloud job.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialFeature; 